<template>
  <div class="order-person-limit">
    <div class="rj-page-card">
      <div class="rj-page-card__content">
        <!-- 筛选 -->
        <el-form ref="Form" :inline="true" class="searchBoxLine" :model="searchForm">
          <el-form-item label="姓名：" prop="name">
            <el-input v-model="searchForm.name" clearable placeholder="请输入姓名" />
          </el-form-item>

          <el-form-item>
            <el-button
              ref="searchBtn"
              type="primary"
              :loading="isLoading"
              @click="searchData"
            >
              查询
            </el-button>
          </el-form-item>

          <el-form-item>
            <el-button
              ref="searchBtn"
              type="default"
              :disabled="!selectList.length"
              @click="showCopyDialog"
            >
              复制
            </el-button>
          </el-form-item>
        </el-form>

        <div v-loading="isLoading" class="tableBody">
          <el-table
            ref="tableDataRef"
            :data="tableData"
            border
            style="width: 100%"
            tooltip-effect="light"
            @selection-change="handleSelection"
          >
            <el-table-column type="selection" width="55" />
            <el-table-column label="序号" type="index" align="left" fixed="left" />
            <el-table-column prop="userName" label="姓名" align="left" />
            <el-table-column prop="areaName" label="区域名称" align="left" />
            <el-table-column prop="deptCode" label="部门编码" align="left" />
            <el-table-column prop="deptName" label="部门名称" align="left" />
            <el-table-column prop="validateStatus" label="状态" align="left">
              <template v-slot="{row}">
                {{ row.validateStatus ? '有效' : '无效' }}
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建日期" align="left" />
            <el-table-column prop="updateTime" label="更新时间" align="left" />
          </el-table>
        </div>

        <div style="text-align: right;margin-top: 10px">
          <el-pagination
            :page-sizes="[10]"
            :page-size.sync="page.pageSize"
            :current-page.sync="page.pageIndex"
            :total="page.total"
            layout="total, prev, pager, next, jumper, sizes"
            @size-change="handerSizeChange"
            @current-change="handerCurrentChange"
          />
        </div>
      </div>
    </div>

    <ruleDialog ref="ruleDialog" @on-ok="setCopySuccessData" />
  </div>
</template>

<script>
import { getBusinessShipList } from '@/API';
import ruleDialog from './ruleDialog.vue';

export default {
  components: {
    ruleDialog
  },

  data () {
    return {
      isLoading: false,
      isLoadingName: false,
      searchForm: {},
      tableData: [],
      selectList: [],
      nameList: [], // 姓名的列表
      page: {
        pageSize: 10,
        pageIndex: 1,
        total: 0
      }
    };
  },

  methods: {
    initData () {
      const params = {
        ...this.searchForm,
        pageIndex: this.page.pageIndex,
        pageSize: this.page.pageSize
      };
      this.isLoading = true;

      getBusinessShipList(params)
        .then(res => {
          const { status, data } = res.data;
          if (status === '200') {
            this.tableData = data.list;
            this.page.total = data.total;
          }
          this.isLoading = false;
        }).catch(() => {
          this.isLoading = false;
        });
    },

    // 搜索
    searchData () {
      if (!this.searchForm.name) return;
      this.page.pageIndex = 1;
      this.initData();
    },

    // 列表选择
    handleSelection (val) {
      this.selectList = val;
    },

    handerSizeChange () {
      this.searchData();
    },

    handerCurrentChange () {
      this.initData();
    },

    // 弹窗打开
    showCopyDialog () {
      this.$refs.ruleDialog.openDialog(this.$cloneDeep(this.selectList));
    },

    // 弹窗成功回调
    setCopySuccessData () {
      this.selectList = [];
      this.$refs.tableDataRef.clearSelection();
    }
  }
};
</script>
